var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElements = function SvgElements(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-4 -4 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF68DB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m9.4 5.829-2 3.2h3.2l-2 3.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF68DB",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M16.209 10.74c.417-.115.626-.172.709-.282s.082-.287.082-.64V8.24c0-.354 0-.53-.082-.64-.083-.11-.292-.168-.71-.283-1.56-.429-2.536-2.093-2.133-3.675.11-.435.166-.652.113-.78-.053-.127-.205-.215-.508-.391l-1.38-.8c-.298-.172-.447-.258-.58-.24-.134.019-.285.172-.586.479a3 3 0 0 1-4.267 0c-.301-.307-.452-.46-.585-.479-.134-.018-.283.068-.58.24l-1.38.8c-.304.176-.456.263-.509.391s.003.345.114.78c.402 1.582-.575 3.246-2.136 3.675-.417.115-.626.173-.709.283S1 7.886 1 8.24v1.578c0 .353 0 .53.082.64.083.11.292.167.71.282 1.56.43 2.536 2.094 2.133 3.675-.11.435-.166.653-.113.78.053.128.205.216.508.391l1.38.8c.298.172.447.259.58.24.134-.018.285-.172.586-.479a3 3 0 0 1 4.27 0c.3.307.451.46.585.48.134.018.283-.069.58-.241l1.38-.8c.304-.175.455-.263.508-.39.053-.128-.002-.346-.113-.78-.403-1.582.573-3.247 2.133-3.676Z"
  })));
};
export default SvgElements;